import { Team } from '@/modules/team/models/Team';
import { User } from '@/modules/user/models/User';
import { BaseWorkflowRule } from '@/modules/workflow/models/BaseWorkflowRule';

export class WorkflowAssignee extends BaseWorkflowRule {
  id?: number;

  modelType?: string;

  modelId?: number;

  user?: Relationship<User>;

  team?: Relationship<Team>;

  constructor(model: Partial<WorkflowAssignee> = {}) {
    super(model);

    this.id = model.id;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.user = User.mapModelOrNull(model.user) || undefined;
    this.team = Team.mapModelOrNull(model.team) || undefined;
  }

  get ruleId(): string | undefined {
    return this.modelId?.toString();
  }
}
